// import React from "react";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
// import FormTable from "../../components/Super Admin/Core Functions/FormsTable";
// import { LogoutButton } from '../../components/Super Admin/NavBar/NavBar';
// import "../../css/FormsPage.css";

// const FormsPage: React.FC = () => {
//   return (
//     <div className="forms-page">
//       {/* <Sidebar /> */}
//       <div className="main-content">
//         {/* <div><LogoutButton /></div> */}
//         <TopTabs />
//         <FormTable />
//       </div>
//     </div>
//   );
// };

// export default FormsPage;




// import React from "react";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
// import FormTable from "../../components/Super Admin/Core Functions/FormsTable";
// // The LogoutButton is likely handled inside your Sidebar or a top navbar, so it's not needed here.
// import "../../css/FormsPage.css";

// const FormsPage: React.FC = () => {
//   return (
//     <div className="forms-page">
//       {/* ✅ Make sure the Sidebar is rendered */}
//       {/* <Sidebar /> */}
//       <div className="main-content">
//         <TopTabs />
//         <FormTable />
//       </div>
//     </div>
//   );
// };

// export default FormsPage;



import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
import FormTable from "../../components/Super Admin/Core Functions/FormsTable";
// import "../../css/FormsPage.css";

const FormsPage: React.FC = () => {
  return (
    <div className="forms-page">
      {/* <Sidebar /> */} {/* Assuming Sidebar is rendered at a higher level or globally */}
      <div className="forms-page-main-content"> {/* Renamed class */}
        <TopTabs />
        <FormTable />
      </div>
    </div>
  );
};

export default FormsPage;